import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectIsAuthenticated } from './redux/slices/auth.slice';
import './styles/Dashboard.css';
import './styles/ui-components.css';
import Layout from './components/Layout';
import Dashboard from './pages/Dashboard';
import Inquiries from './pages/Inquiries';
import InquiryDetails from './pages/InquiryDetails';
import Tournaments from './pages/Tournaments';
import Players from './pages/Players';
import PlayerDetails from './pages/PlayerDetails';
import Committee from './pages/Committee';
import CommitteeForm from './pages/CommitteeForm';
import Designations from './pages/Designations';
import Contacts from './pages/Contacts';
import News from './pages/News';
import About from './pages/About';
import Gallery from './pages/Gallery';
import UIShowcase from './pages/UIShowcase';
import Roles from './pages/Roles';
import RoleForm from './pages/RoleForm';
import Permissions from './pages/Permissions';
import Admins from "./pages/Admins";
import AdminForm from "./pages/AdminForm";
import Signin from './pages/Signin';

import { Toaster } from 'react-hot-toast';

// PrivateRoute uses Redux state instead of localStorage
const PrivateRoute = ({ children }) => {
  const isAuthenticated = useSelector(selectIsAuthenticated);
  return isAuthenticated ? children : <Navigate to="/" replace />;
};

function App() {
  const isAuthenticated = useSelector(selectIsAuthenticated);

  return (
    <Router>
      <Toaster position="top-right" reverseOrder={false} />
      <Routes>
        {/* Public route - redirect to dashboard if already logged in */}
        <Route 
          path="/" 
          element={
            isAuthenticated ? <Navigate to="/dashboard" replace /> : <Signin />
          } 
        />

        {/* Protected routes wrapped in Layout */}
        <Route
          path="/*"
          element={
            <PrivateRoute>
              <Layout>
                <Routes>
                  <Route path="/dashboard" element={<Dashboard />} />
                  <Route path="/inqueries" element={<Inquiries />} />
                  <Route path="/inqueries/:id" element={<InquiryDetails />} />
                  <Route path="/tournaments" element={<Tournaments />} />
                  <Route path="/players" element={<Players />} />
                  <Route path="/players/:id" element={<PlayerDetails />} />
                  <Route path="/committee" element={<Committee />} />
                  <Route path="/committee/create" element={<CommitteeForm />} />
                  <Route path="/committee/edit/:id" element={<CommitteeForm />} />
                  <Route path="/designations" element={<Designations />} />
                  <Route path="/contacts" element={<Contacts />} />
                  <Route path="/news" element={<News />} />
                  <Route path="/about" element={<About />} />
                  <Route path="/gallery" element={<Gallery />} />
                  <Route path="/ui-showcase" element={<UIShowcase />} />
                  <Route path="/roles" element={<Roles />} />
                  <Route path="/roles/create" element={<RoleForm />} />
                  <Route path="/roles/edit/:id" element={<RoleForm />} />
                  <Route path="/permissions" element={<Permissions />} />
                  <Route path="/admins" element={<Admins />} />
                  <Route path="/admins/new" element={<AdminForm />} />
                  <Route path="/admins/edit/:id" element={<AdminForm />} />
                </Routes>
              </Layout>
            </PrivateRoute>
          }
        />
      </Routes>
    </Router>
  );
}

export default App;
